module.exports = __webpack_public_path__ + "img/share-guide.c7ab284a.png";